/**
 * API Configuration
 */
export const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

/**
 * Chart period configurations for stock charts
 *
 * Feb 2026 (bugfix mapping): antes 1D mapeaba a period='6mo' interval='1d'
 * (¡6 meses de velas diarias!). Corregido para que cada label represente
 * SIEMPRE el horizonte temporal mostrado, con un `interval` coherente:
 *   - 1D  → sesión de HOY, velas 5m (yfinance limita interval=5m a 60 días)
 *   - 5D  → últimos 5 días, velas 30m
 *   - 1M  → 1 mes, velas diarias
 *   - 3M  → 3 meses, velas diarias
 *   - 6M  → 6 meses, velas diarias (~130 velas)
 *   - 1A  → 1 año, velas diarias (~250 velas)
 *   - 5A  → 5 años, velas semanales (~260 velas)
 *   - MAX → todo el histórico, velas mensuales
 * Los intradías (5m/15m/1H/4H) muestran los últimos 5 días o 1-3 meses según
 * la granularidad, para dar contexto suficiente al trader.
 */
export const CHART_PERIODS = [
  { id: '5m',  label: '5m',  period: '5d',  interval: '5m',  aggregate: 1 },
  { id: '15m', label: '15m', period: '5d',  interval: '15m', aggregate: 1 },
  { id: '1H',  label: '1H',  period: '1mo', interval: '1h',  aggregate: 1 },
  { id: '4H',  label: '4H',  period: '3mo', interval: '1h',  aggregate: 4 },
  { id: '1D',  label: '1D',  period: '1d',  interval: '5m',  aggregate: 1 },
  { id: '5D',  label: '5D',  period: '5d',  interval: '30m', aggregate: 1 },
  { id: '1M',  label: '1M',  period: '1mo', interval: '1d',  aggregate: 1 },
  { id: '3M',  label: '3M',  period: '3mo', interval: '1d',  aggregate: 1 },
  { id: '6M',  label: '6M',  period: '6mo', interval: '1d',  aggregate: 1 },
  { id: '1A',  label: '1A',  period: '1y',  interval: '1d',  aggregate: 1 },
  { id: '5A',  label: '5A',  period: '5y',  interval: '1wk', aggregate: 1 },
  { id: 'MAX', label: 'MAX', period: 'max', interval: '1mo', aggregate: 1 },
];

export const DEFAULT_TICKER = 'NVDA';
export const REFRESH_INTERVAL_MS = 60000; // 60 seconds
